import { IEntityMap, IMappable } from '../../types';

/**
 * @description converts an array of entities into a map keyed by the entity id for quick lookups
 * @param {IMappable[]} items an array of `mappable` (contains id property) entities
 * @returns {IEntityMap}
 */
export const entitiesAsMap = (items: IMappable[]): IEntityMap => {
  return items.reduce((acc: IEntityMap, curr: IMappable): IEntityMap => {
    acc[curr.id] = curr;
    return acc;
  }, {});
};
